"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ROLES = void 0;
const uniq_1 = __importDefault(require("lodash/uniq"));
const REGIONAL_MANAGER_PERMISSIONS = [
    "Pin_Myself:Read",
    "User_Driver_CanSpeakEnglish:Update",
    "DynamicFormConfig:Read",
    "DriverVat:Validate",
    "AssignationOffersPage:Read",
    "Unavailability:Read",
    "DriversPage:Read",
    "CompaniesPage:Read",
    "DriversMapPage:Read",
    "MangopayInformation:Read",
    "MangopayInformation:Update",
    "BillingInformationPage:Read",
    "BillingInformation:Modify",
    "User_Driver:Create",
    "User_Driver:Update",
    "User_Driver_RM:Modify",
    "User_Driver:AssignToCompany",
    "DriversCompany:Read",
    "DriversCompanies:Read",
    "DriversCompany:Modify",
    "DriverVehicle:Update",
    "DriverVehicle:Approve",
    "DriverBalance:Read",
    "DriverCustomerFeedback:Read",
    "DriversFeedbacksPage:Read",
    "DriverDocument:Modify",
    "DriverVehicleDocument:Modify",
    "DriverDocument:Approve",
    "Drivers:Read",
    "DriverAssignations:Read",
    "UserInvoicingData:Read",
    "Vehicle:Create",
    "CanClaimTrips:Read",
    "ClaimingToolSubscription:Read",
    "DriverProfilePage:Read",
    "DriverVehiclesPage:Read",
    "PasswordResetPage:Read",
];
const FINANCE_ROLE_PERMISSIONS = [
    "InternalManagement:Access",
    "Fresh",
    "ContentCountriesPage:Read",
    "ContentCurrenciesPage:Read",
    "ContentNumberingTemplatesPage:Read",
    "ContentExportsPage:Read",
    "DriversPage:Read",
    "DriversFeedbacksPage:Read",
    "CompaniesPage:Read",
    "Payout:Read",
    "AssignationsPage:Read",
    "BillingInformationPage:Read",
    "Invoice:Read",
    "DriverProfilePage:Read",
    "DriverVehiclesPage:Read",
    "OrdersPage:Read",
    "CustomersPage:Read",
    "HostAgenciesPage:Read",
    "TravelAgentsPage:Read",
    "ApiPartnersPage:Read",
    "PartnersPage:Read",
    "PaymentsPage:Read",
    "RidesPage:Read",
    "CreditLine:Read",
    "Numbering_Template:Read",
    "User:Read",
    "UserInvoicingData:Read",
    "OrdersPrices:Export",
    "Order:Read",
    "Orders:Read",
    "Drivers:Read",
    "DriversCompany:Read",
    "DriversCompanies:Read",
    "DriverBalance:Read",
    "DriverCustomerFeedback:Read",
    "DriverAssignations:Read",
    "MangopayInformation:Read",
    "Payments:Read",
    "Unavailability:Read",
    "User_Driver:Update",
    "User_Driver_ShowInvoicingInfo:Update",
    "DriverVat:Validate",
    "MangopayInformation:Read",
    "MangopayInformation:Update",
    "BillingInformationPage:Read",
    "BillingInformation:Modify",
    "DriversCompany:Modify",
    "DriverDocument:Modify",
    "DriverDocument:Approve",
    "DriverVehicleDocument:Modify",
    "OrderClaims:Read",
    "Payments:Read",
    "Chargebacks:Read",
    "TravelAgents:Read",
    "Partners:Read",
    "ApiPartners:Read",
    "ApiPartners:Create",
    "ApiPartners:Update",
    "ApiPartners:Delete",
];
const ROLES = {
    product: [],
    "user-role-manager": ["UserRoles:Full", "User:Create", "User:Update", "User:Delete", "InternalManagement:Access"],
    admin: ["User:Delete"],
    // generic role that allows users to log in to management portal
    "management-access": ["User_Myself:Read", "User_Myself:Update", "UserPassword_Myself:Modify"],
    "refund-master": ["RefundsPage:Read", "Chargeback:Create"],
    "payout-master": [
        "Payout:Read",
        "Payout:Create",
        "Payout:Approve",
        "Payout:Send",
        "Payout:Fail",
        "Payout:Update",
        "Payout:Delete",
        "CreditLine:Modify",
        "CreditLine:Read",
    ],
    "customer-support": [
        "OrdersPage:Read",
        "CustomersPage:Read",
        "HostAgenciesPage:Read",
        "TravelAgentsPage:Read",
        "ApiPartnersPage:Read",
        "PartnersPage:Read",
        "ReferralCodesPage:Read",
        "PaymentsPage:Read",
        "OrdersAddressCheckPage:Read",
        "CustomersFeedbacksPage:Read",
        "BlacklistedDepartureDatesPage:Read",
        "RidesPage:Read",
        "CooperationAgreementPage:Read",
        "ContentLocationsPage:Read",
        "ContentCountriesPage:Read",
        "ComboAssignationPage:Read",
        "DriverProfilePage:Read",
        "DriverVehiclesPage:Read",
        "InternalManagement:Access",
        "ReferralCode:Create",
        "User:Read",
        "User:Create",
        "User:Update",
        "User_Customer:Modify",
        "UserInvoicingData:Read",
        "Order:Create",
        "Order:Read",
        "Order:Update",
        "Order:Cancel",
        "Order:Confirm",
        "OrderAddress:Approve",
        "OrdersPrices:Export",
        "Orders:Read",
        "Assignation:Modify",
        "Chargebacks:Read",
        "Chargeback_Cancelled:Create",
        "Chargeback_Surplus:Create",
        "Chargeback_ForNeverConfirmedOrder:Create",
        "Partners:Read",
        "Partners:Create",
        "Partners:Update",
        "Partners:Delete",
        "ApiPartners:Read",
        "ApiPartners:Create",
        "ApiPartners:Update",
        "ApiPartners:Delete",
        "CustomerInterfaceFromManagement:Read",
        "Feedback_Management:Create",
        "Fresh",
        "DynamicFormConfig:Read",
        "OrderClaims:Read",
        "ClaimingToolSubscription:Read",
        "AssignationOffersPage:Read",
        "AssignationOffer:Full",
        "CreditLine:Read",
        "VehicleModel:Read",
        "Vehicle:Create",
        "BlacklistedDepartureDates:Read",
        "DriversMapPage:Read",
        "DriversPage:Read",
        "CompaniesPage:Read",
        "DriversCompany:Read",
        "DriversCompanies:Read",
        "DriversCompany:Modify",
        "DriverVehicle:Update",
        "DriverVehicle:Approve",
        "DriverBalance:Read",
        "DriverCustomerFeedback:Read",
        "DriverDocument:Modify",
        "DriverVehicleDocument:Modify",
        "DriverDocument:Approve",
        "Drivers:Read",
        "DriverAssignations:Read",
        "DriversFeedbacksPage:Read",
        "MangopayInformation:Read",
        "MangopayInformation:Update",
        // "BillingInformation:Modify",
        "Payment:Create",
        "PaymentRequest:Create",
        "Payments:Read",
        "Discount:Create",
        "Numbering_Template:Read",
        "TravelAgent:Modify",
        "TravelAgents:Read",
        "Location:Read",
        "Location:Create",
        "Location:Update",
        "Route:Read",
        "Route:Create",
        "Route:Update",
    ],
    "driver-support": [
        "InternalManagement:Access",
        "ContentCountriesPage:Read",
        "ContentMapPage:Read",
        "ContentLocationsPage:Read",
        "CustomersPage:Read",
        "OrdersAddressCheckPage:Read",
        "RidesPage:Read",
        "CustomerInterfaceFromManagement:Read",
        "AssignationTool:Read",
        "AssignationOffersPage:Read",
        "AssignationOffer:Full",
        "ComboAssignationPage:Read",
        "OrderCombos:Read",
        "ComboAssignationOffer:Modify",
        "DriverProfilePage:Read",
        "DriverVehiclesPage:Read",
        "PasswordResetPage:Read",
        "User:Read",
        "User:Create",
        "User:Update",
        "UserInvoicingData:Read",
        "User_Driver:Create",
        "User_Driver:Update",
        "User_Driver:Delete",
        "User_Driver_CanSpeakEnglish:Update",
        "User_Driver:AssignToCompany",
        "User_Driver_ShowInvoicingInfo:Update",
        "Order:Read",
        "Order:Update",
        "OrdersPrices:Export",
        "Orders:Read",
        "CustomersFeedbacksPage:Read",
        "Assignation:Modify",
        "AssignationClaim:Update",
        "Chargebacks:Read",
        "Chargeback_Cancelled:Create",
        "Chargeback_Surplus:Create",
        "Chargeback_ForNeverConfirmedOrder:Create",
        "Payout:Read",
        "Payout:Create",
        "Payout_Pending:Fail",
        "Numbering_Template:Read",
        "Numbering_Template:Create",
        "Numbering_Template:Delete",
        "Invoice:Generate",
        "Invoice:CSVExport",
        "Invoice:Read",
        "Feedback_Management:Create",
        "Unavailability:Read",
        "Unavailability:Update",
        "Fresh",
        "DynamicFormConfig:Read",
        "OrderClaims:Read",
        "ClaimingToolSubscription:Read",
        "CanClaimTrips:Read",
        "DriverVat:Validate",
        "VehicleModel:Read",
        "Vehicle:Create",
        "OrdersPage:Read",
        "DriversPage:Read",
        "CompaniesPage:Read",
        "DriversMapPage:Read",
        "DriversBalancePage:Read",
        "AssignationsPage:Read",
        "DocumentTypesPage:Read",
        "CooperationAgreementPage:Read",
        "DriverCountryRulesPage:Read",
        "DriversFeedbacksPage:Read",
        "MangopayInformation:Read",
        "MangopayInformation:Update",
        "BillingInformationPage:Read",
        "BillingInformation:Modify",
        "DriversCompany:Read",
        "DriversCompanies:Read",
        "DriversCompany:Modify",
        "DriverVehicle:Update",
        "DriverVehicle:Approve",
        "DriverBalance:Read",
        "DriverCustomerFeedback:Read",
        "DriverDocument:Modify",
        "DriverDocument:Approve",
        "DriverVehicleDocument:Modify",
        "Drivers:Read",
        "DriverAssignations:Read",
        "Payment:Create",
        "Payments:Read",
    ],
    "support-master": [
        "Order:Confirm",
        "Order:ConfirmWithoutValidation",
        "VehicleModel:Read",
        "VehicleModel:Modify",
        "SubsidyOverLimit:Modify",
        "CompensationOverLimit:Modify",
    ],
    "content-manager": [
        "ContentMapPage:Read",
        "ContentCountriesPage:Read",
        "ContentLocationsPage:Read",
        "ContentRoutesPage:Read",
        "ContentTagsPage:Read",
        "ContentTravelDataPage:Read",
        "ContentCurrenciesPage:Read",
        "ContentExportsPage:Read",
        "ContentTranslationsPage:Read",
        "ContentLanguagesPage:Read",
        "ContentNumberingTemplatesPage:Read",
        "ContentFlexibleOffersPage:Read",
        "User:Read",
        "InternalManagement:Access",
        "Country:Modify",
        "Location:Read",
        "Location:Create",
        "Location:Update",
        "Location:Delete",
        "Discount:Create",
        "Discount:Read",
        "Discount:Update",
        "Discount:Delete",
        "Route:Create",
        "Route:Update",
        "Route:Delete",
        "Route:Read",
        "Numbering_Template:Read",
        "BlacklistedDepartureDates:Read",
        "BlacklistedDepartureDates:Modify",
        "Translation:Modify",
    ],
    "campaigns-manager": [],
    bizdev: [
        "ApiPartners:Create",
        "ApiPartners:Read",
        "ApiPartners:Update",
        "ApiPartners:Delete",
        "ApiPartnersPage:Read",
        "Chargebacks:Read", // needed on Order page
        "ContentCountriesPage:Read",
        "ContentLocationsPage:Read",
        "ContentMapPage:Read",
        "ContentRoutesPage:Read",
        "CreditLine:Read",
        "CustomersPage:Read",
        "Fresh",
        "HostAgenciesPage:Read",
        "InternalManagement:Access",
        "Location:Read",
        "MangopayInformation:Read",
        "Numbering_Template:Read", // needed on Country page
        "Order:Read",
        "OrderClaims:Read", // needed on Order page
        "Orders:Read",
        "OrdersPage:Read",
        "Partners:Create",
        "Partners:Read",
        "Partners:Update",
        "Partners:Delete",
        "PartnersPage:Read",
        "Payments:Read", // needed on Order page
        "ReferralCode:Create",
        "ReferralCodesPage:Read",
        "Route:Read",
        "TravelAgent:Delete",
        "TravelAgent:Modify",
        "TravelAgents:Read",
        "TravelAgentsPage:Read",
        "User:Read",
        "User_Myself:Read",
    ],
    driver: [
        "Pin_Myself:Read",
        "Invoice_Myself:Read",
        "Unavailability_Myself:Read",
        "Unavailability_Myself:Update",
        "AssignationOffers_NearDriver:Read",
        "AssignationOffers_Personal:Read",
        "AssignationOffers_Personal:Accept",
        "AssignationOffers_Personal:Decline",
        "AssignationOffer:Read",
        "Assignation_Myself:Modify",
        "AssignationsData_Myself:Read",
        "BillingInformationPage:Read",
        "BillingInformation_Myself:Modify",
        "User_Driver_Myself:Read",
        "User_Driver_Myself:Update",
        "DriverDocument_Myself:Modify",
        "DriverBalance_Myself:Read",
        "DriverProfilePage:Read",
        "DriverVehiclesPage:Read",
        "DriverVehicle_Myself:Update",
        "DriverVehicleDocument_Myself:Modify",
        "MangopayInformation_Myself:Update",
        "DriverVat:Validate",
        "Vehicle_Myself:Create",
        "PasswordResetPage:Read",
    ],
    "drivers-company": [
        "User_MyCompanyDriver:Read",
        "User_MyCompanyDriver:Create",
        "User_MyCompanyDriver:Update",
        "User_MyCompanyDriver:Delete",
        "Pin_Myself:Read",
        "Invoice_Myself:Read",
        "Unavailability_Myself:Read",
        "Unavailability_Myself:Update",
        "AssignationOffers_NearDriver:Read",
        "AssignationOffers_Personal:Read",
        "AssignationOffers_Personal:Accept",
        "AssignationOffers_Personal:Decline",
        "AssignationOffer:Read",
        "Assignation_Myself:Modify",
        "AssignationsData_Myself:Read",
        "BillingInformationPage:Read",
        "BillingInformation_Myself:Modify",
        "DriversCompany_Myself:Read",
        "DriversCompany_Myself:Modify",
        "User_Driver_Myself:Read",
        "User_Driver_Myself:Update",
        "DriverDocument_Myself:Modify",
        "DriverBalance_Myself:Read",
        "DriverProfilePage:Read",
        "DriverVehiclesPage:Read",
        "DriverVehicle_Myself:Update",
        "DriverVehicleDocument_Myself:Modify",
        "MangopayInformation_Myself:Update",
        "DriverVat:Validate",
        "PasswordResetPage:Read",
        "Vehicle_Myself:Create",
    ],
    "drivers-company-driver": [
        "Pin_Myself:Read",
        "My_DriversCompany:Read",
        // TODO: check if we really need the company driver to have these permissions
        // been added as a result of removing userId authorization option #sc-32871
        "Assignation_Myself:Modify",
        "AssignationsData_Myself:Read",
        "User_Driver_Myself:Read",
        "User_Driver_Myself:Update",
        "DriverDocument_Myself:Modify",
        "DriverBalance_Myself:Read",
        "DriverProfilePage:Read",
        "DriverVehiclesPage:Read",
        "DriverVehicle_Myself:Update",
        "DriverVehicleDocument_Myself:Modify",
        "MangopayInformation_Myself:Update",
        "Vehicle_Myself:Create",
    ],
    "regional-manager": REGIONAL_MANAGER_PERMISSIONS,
    "senior-regional-manager": [
        "OrdersPage:Read",
        "OrderInAssignedCountries:Read",
        "OrderInAssignedCountries:Update",
        "OrderClaims:Read",
        "Assignation:Modify",
        "AssignationTool:Read",
        "AssignationOffer:Full",
        "Unavailability:Update",
        "Fresh",
        "VehicleModel:Read",
        "BlacklistedDepartureDatesPage:Read",
        "BlacklistedDepartureDates:Read",
        "Payments:Read",
        "Chargebacks:Read",
        "Numbering_Template:Read",
        "ComboAssignationPage:Read",
        ...REGIONAL_MANAGER_PERMISSIONS,
    ],
    "can-claim-trips": [
        "ClaimOrderRequest_Myself:Create",
        "ClaimOrderRequest_Myself:Read",
        "ClaimOrderRequest_Myself:Delete",
        "ClaimingToolSubscription_Myself:Read",
    ],
    "ca-master": ["DynamicFormConfig:Manage"],
    "claiming-tool-subscription-master": [
        "OrderClaims:Read",
        "ClaimingToolSubscription:Create",
        "ClaimingToolSubscription:Activate",
        "ClaimingToolSubscription:Deactivate",
        "ClaimingToolSubscription:Read",
    ],
    finance: FINANCE_ROLE_PERMISSIONS,
    "finance-master": [
        ...FINANCE_ROLE_PERMISSIONS,
        "DocumentTypesPage:Read",
        "ReferralCodesPage:Read",
        "BlacklistedDepartureDatesPage:Read",
        "Country:Modify",
        "Currency:Modify",
        "Numbering_Template:Create",
        "Numbering_Template:Delete",
        "Payout:Approve",
        "Payout:Send",
        "Payout:Create",
        "Payout:Fail",
        "Payout_Pending:Fail",
        "CreditLine:Modify",
        "ReferralCode:Create",
    ],
    "blacklisted-dates-api-integration": ["BlacklistedDepartureDates:Read", "BlacklistedDepartureDates:Modify"],
    // --- site related roles ---
    "site-customer": [
        "Order_Myself:Create",
        "Order_Myself:Read",
        "OrderPage:Read",
        "Feedback_Myself:Read",
        "Feedback_Myself:Create",
        "Feedback_Myself:Update",
        "User_Myself:Read", // it is needed for retrieveUser, but is it safe to add it to customers?
        "User_Myself:Update", // it is needed for updateUser, but is it safe to add it to customers?
        "MangopayInformation_Myself:Update",
        "Payment_Myself:Create",
    ],
    "site-customer-customer-interface": [
        "Order_Myself:Create",
        "Order_Myself:Read",
        "Order_Myself:Update",
        "Order_Myself:Cancel",
        "OrderPage:Read",
        "Orders_Myself:Read",
        "CustomerInterface:Read",
        "Feedback_Myself:Read",
        "Feedback_Myself:Create",
        "Feedback_Myself:Update",
        "LatestDriverLocation:Read",
        "User_Myself:Read", // it is needed for retrieveUser, but is it safe to add it to customers?
        "User_Myself:Update", // it is needed for updateUser, but is it safe to add it to customers?
        "MangopayInformation_Myself:Update",
        "Payment_Myself:Create",
    ],
    "site-customer-booking-process": [
        "Order_Myself:Read",
        "OrderPage:Read",
        "Order_Myself:Cancel",
        "User_Myself:Read", // it is needed for retrieveUser, but is it safe to add it to customers?
        "User_Myself:Update", // it is needed for updateUser, but is it safe to add it to customers?
        "MangopayInformation_Myself:Update",
        "Payment_Myself:Create",
    ],
    "payment-request": ["User_Myself:Read", "User_Myself:Update", "Payment_Myself:Create"],
    "site-customer-trip-tracking": ["LatestDriverLocation:Read", "Order_Myself:Read", "User_Myself:Read"],
    "travel-agent": ["UserPassword_Myself:Modify"],
    developer: [],
};
exports.ROLES = ROLES;
ROLES.admin = (0, uniq_1.default)([
    ...ROLES.admin,
    ...ROLES["customer-support"],
    ...ROLES["driver-support"],
    ...ROLES["content-manager"],
    ...ROLES["campaigns-manager"],
    ...ROLES["user-role-manager"],
    ...ROLES["payout-master"],
    ...ROLES["refund-master"],
    ...ROLES["support-master"],
    ...ROLES["ca-master"],
    ...ROLES["claiming-tool-subscription-master"],
    ...ROLES.finance,
    ...ROLES["finance-master"],
]);
ROLES.product = (0, uniq_1.default)([
    ...ROLES.product,
    ...ROLES["customer-support"],
    ...ROLES["driver-support"],
    ...ROLES["content-manager"],
    ...ROLES["campaigns-manager"],
    ...ROLES["support-master"],
    ...ROLES["ca-master"],
    ...ROLES.finance,
    ...ROLES["finance-master"],
]);
//# sourceMappingURL=rolesWithPermissions.js.map